



























import {Component, Prop, Vue} from "vue-property-decorator";
import {IdCard} from "../modules/models";
import CardIcon from "./CardIcon.vue";

@Component({
    components: {
        "at-card-icon": CardIcon,
    }
})
export default class HmsCardDisplay extends Vue {
    @Prop()
    card!: IdCard;
}
